import axios from 'axios'
import React, { useState } from 'react'
import { ApiConnectionString } from '../../../constants/ApiConntection'
import { useAuthContext } from '../../../hooks/useAuthContext'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function UnBlockModal({cancelModal,id,username,fetchData}) {
    const [complete,setComplete] = useState(false)
    const {user} = useAuthContext();
    const [isLoading,setIsLoading] = useState(false)

    // styled
    const handleBlock = async () => {
        setIsLoading(true); // Start loading
      
        try {
          const blockResponse = await axios.put(
            `${ApiConnectionString}/api/convo/Unblock/${id}`,
            {},
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          );
      
          if (blockResponse.status === 200) {
            setComplete(true); // Set complete state if successful
            fetchData()
          }
        } catch (error) {
          console.error('Error blocking the conversation:', error);
          // You can set an error state here if needed
        } finally {
          setIsLoading(false); // Stop loading regardless of success or error
        }
      };
      

      if(isLoading){
        return (
            <div className="send-modal-overlay">
          
            <div className="send-modal">
          <LoadingSpinner />
            
                <div className="send-modal-footer">
              
                </div>
            
            </div>
          </div>
          )
      }

      else{
        if(complete){
            return (
                <div className="send-modal-overlay">
              
                <div className="send-modal">
                <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>User Unblocked</p></div> 
                <p>{username} is now unblocked.</p>
                <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
                    <div className="send-modal-footer">
                    <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>
                    </div>
                
                </div>
              </div>
              )
        }else{
            return (
                <div className="send-modal-overlay">
              
                <div className="send-modal">
                <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Unblock User</p></div> 
                <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
                  <p>Are you sure that you want to Unblock {username}?</p>
                    <div className="send-modal-footer">
                      <button className="saveChanges-button mx-3" onClick={handleBlock}>Confirm</button>
                      <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
                    </div>
                
                </div>
              </div>
              )
        }
      }
  
 
    }
    